import React from "react";
import ProjectsHomePage from "../../components/Project/ProjectsHomePage";
import Footer from "../../components/Footer/Footer";

const Projects = () => {
  return (
    <>
      <ProjectsHomePage />
      <Footer></Footer>
    </>
  );
};

export default Projects;
